import React, { useState } from "react";
import { HiOutlinePencilSquare } from "react-icons/hi2";
import logosIcon from "../../../assets/logosIcon.png";
import { trpc } from "../../main/components/trpc.ts";

interface LogosLinkProps {
  fileNumber: number | null;
  patientId: string;
}

const LogosLink = (props: LogosLinkProps) => {
  const { fileNumber, patientId } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(fileNumber?.toString() || "");

  const utils = trpc.useUtils();

  const updateFileNumberMutation = trpc.logos.setLogosFileNumber.useMutation({
    onSuccess: () => {
      utils.patient.invalidate();
    },
  });

  const handleIconClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (fileNumber) {
      // Conserver le comportement historique: ouverture LOGOS
      window.location.href = `cadendar://logosfile/open/${fileNumber}`;
    } else {
      // Sans numéro de fichier, rester sur le flux historique: saisie
      setIsEditing(true);
      setInputValue("");
    }
  };

  const handleEditClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsEditing(true);
    setInputValue(fileNumber?.toString() || "");
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // N'accepter que les chiffres et limiter à 5 caractères
    if (/^\d*$/.test(value) && value.length <= 5) {
      setInputValue(value);
    }
  };

  const handleInputSubmit = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      const newFileNumber = parseInt(inputValue);
      console.log("New file number:", newFileNumber);
      if (!isNaN(newFileNumber) && newFileNumber > 0) {
        updateFileNumberMutation.mutate({
          fileNumber: newFileNumber,
          patientId: patientId,
        });
      }
      setIsEditing(false);
    } else if (e.key === "Escape") {
      setIsEditing(false);
      setInputValue(fileNumber?.toString() || "");
    }
  };

  const handleInputBlur = () => {
    const newFileNumber = parseInt(inputValue);
    if (!isNaN(newFileNumber) && newFileNumber > 0) {
      updateFileNumberMutation.mutate({
        fileNumber: newFileNumber,
        patientId: patientId,
      });
    }
    setIsEditing(false);
  };

  return (
    <div className="flex items-center">
      {isEditing ? (
        <div className="flex items-center">
          <img src={logosIcon} className="w-4 h-4 mr-1" />
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={handleInputSubmit}
            onBlur={handleInputBlur}
            className="w-20 px-1 py-0 text-xs border border-gray-300 rounded text-gray-900 bg-white"
            placeholder="N° fichier"
            autoFocus
          />
        </div>
      ) : (
        <>
          <span
            className="flex items-center cursor-pointer hover:bg-gray-800 hover:text-white rounded px-1 py-0"
            onClick={handleIconClick}
            title={
              fileNumber
                ? `Clic: Ouvrir le fichier LOGOS ${fileNumber}`
                : "Cliquer pour saisir le numéro de fichier"
            }
          >
            <img src={logosIcon} className="w-4 h-4" />
            {fileNumber && <span className="ml-1">{fileNumber}</span>}
          </span>
          <span
            className="flex cursor-pointer text-gray-400 hover:text-white hover:bg-gray-800 rounded  py-1 px-1"
            onClick={handleEditClick}
            title="Éditer le numéro de fichier"
          >
            <HiOutlinePencilSquare className="w-3 h-3" />
          </span>

        </>
      )}
    </div>
  );
};

export default LogosLink;
